import { useGetList } from 'react-admin';
import type { Merchant, MerchantRegion, StoreChannel } from '../dataProvider';
import { buildRegionViews, type RegionScopeView } from './rateRuleScope';

/**
 * The catalog the rate-rule previews resolve OVER (D-rate-rules). Reads the
 * merchant_regions, merchants and store_channels the multi-channel lead
 * established and assembles the per-store views the scope count and the resolver
 * read. The previews are a PROJECTION over this current catalog, never the live
 * per-click resolution.
 */
export const useRateRuleCatalog = (): {
  views: RegionScopeView[];
  isLoading: boolean;
} => {
  const big = { pagination: { page: 1, perPage: 1000 } } as const;
  const regions = useGetList<MerchantRegion>('merchantRegions', big);
  const merchants = useGetList<Merchant>('merchants', big);
  const channels = useGetList<StoreChannel>('storeChannels', big);

  const isLoading =
    regions.isLoading || merchants.isLoading || channels.isLoading;
  const views = isLoading
    ? []
    : buildRegionViews(
        regions.data ?? [],
        merchants.data ?? [],
        channels.data ?? [],
      );
  return { views, isLoading };
};
